import cx from 'classnames';
import React, { useCallback } from 'react';
import ItemTypes from '../ItemTypes';
import FormElementWrapper from '../components/FormElementWrapper';
import { mapItemTypeToBaseFormElement } from '../defaults/baseFormElements';
import Dubstin from '../multi-column/dustbin';
import { ItemsTypes } from '../toolbar';

const TwoColumnLayout = props => {
  const {
    seq,
    index,
    registers,
    isBuilder,
    moveCard,
    setAsChild,
    editModeOn,
    removeChild,
    getDataById,
    onChange,
    getItemValueById,
    onAddItem,
    onUpdateElement,
    onUpdateMultipleElements,
    onBulkManipulation,
    onToggleEditing,
    editing,
    readOnly,
    disabled,
    onDelete,
  } = props;

  const getElement = useCallback(
    id => {
      const item = getDataById(id);
      const itemValue = getItemValueById(id);
      const Element = mapItemTypeToBaseFormElement[item?.type];

      if (Element) {
        return (
          <Element
            editing={editing}
            data={item}
            registers={registers}
            value={
              item.type === ItemsTypes.FileUpload ? itemValue?.map(x => x?.value) : itemValue?.value
            }
            itemValue={itemValue}
            onChange={onChange}
            readOnly={readOnly}
            disabled={disabled}
            onDelete={onDelete}
          />
        );
      }
    },
    [getDataById, getItemValueById, onChange, registers, readOnly, editing, disabled, onDelete],
  );

  return (
    <FormElementWrapper {...props}>
      <div className="grid grid-cols-2 gap-8">
        {props.data.childItems.map((id, i) => (
          <div
            className={cx({
              'border rounded-lg border-[#E3E3E3]': isBuilder && !id,
            })}
            key={i}
          >
            {isBuilder ? (
              <Dubstin
                isBuilder={isBuilder}
                style={{
                  width: '100%',
                  // height: '100%',
                  border: 'none',
                  minHeight: 100,
                }}
                data={props.data}
                accepts={[ItemTypes.BOX, ItemTypes.CARD]}
                items={props.data.childItems}
                col={i}
                parentIndex={index}
                editModeOn={editModeOn}
                id={props.data.id}
                moveCard={moveCard}
                index={index}
                onAddItem={onAddItem}
                onBulkManipulation={onBulkManipulation}
                onUpdateElement={onUpdateElement}
                onUpdateMultipleElements={onUpdateMultipleElements}
                _onDestroy={() => removeChild(props.data, i)}
                getDataById={getDataById}
                setAsChild={setAsChild}
                registers={registers}
                seq={seq}
                onToggleEditing={onToggleEditing}
              />
            ) : (
              getElement(id)
            )}
          </div>
        ))}
        {isBuilder && (
          <div
            className="absolute h-full border-l border-[#E3E3E3] top-0"
            style={{ left: '50%' }}
          />
        )}
      </div>
    </FormElementWrapper>
  );
};

export default TwoColumnLayout;
